import React from "react";

import { Box, Grid } from "@material-ui/core";

import { Skeleton } from "@material-ui/lab";

const PersonalDetailsSkeleton: React.FC = () => (
  <Grid container spacing={5}>
    <Grid item xs={12} md={6}>
      <Box mb={2}>
        <Skeleton width="200px" height="40px" />
      </Box>
      <Skeleton width="300px" height="60px" />
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />
    </Grid>
    <Grid item xs={12} md={6}>
      <Box mb={2}>
        <Skeleton width="200px" height="40px" />
      </Box>
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />
      <Skeleton width="100%" height="60px" />

      <Box mt={5}>
        <Skeleton width="200px" height="40px" />

        <Skeleton width="100%" height="60px" />
        <Grid container spacing={2}>
          <Grid item>
            <Skeleton width={50} height="40px" />
          </Grid>
          <Grid item>
            <Skeleton width={50} height="40px" />
          </Grid>
          <Grid item>
            <Skeleton width={50} height="40px" />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  </Grid>
);

export default PersonalDetailsSkeleton;
